import { Box, Typography } from "@mui/material";
import { Tooltip } from "@mui/material";

const IconLabel = ({
    icon,
    tooltip,
    children,
    isTop = false,
    sx,
}: {
    icon: React.ReactNode;
    tooltip: string;
    children: React.ReactNode;
    sx?: object;
    isTop?: boolean;
}) => (
    <Typography variant={isTop ? "subtitle2" : "caption"}
        sx={{
            display: "flex",
            alignItems: isTop ? "center" : "flex-start",
            gap: 0.5,
            flexDirection: isTop ? "row" : "row-reverse",
            justifyContent: isTop ? "flex-start" : "flex-end",
            textAlign: "right",
            color: "gray",
            textTransform: "capitalize",
            ...sx,
        }}>
        <Tooltip title={tooltip} arrow placement="top">
            <Box component="span" sx={{
                display: "flex",
                alignItems: isTop ? "center" : "flex-start",
                mr: 0.25,
                lineHeight: 1,
                ...sx,
            }}>
                {icon}
            </Box>
        </Tooltip>
        {children}
    </Typography>
);

export default IconLabel;